<div class="bmark-summary__client-orders__container">
  <div
    style="display: flex; flex-direction: row; align-items: stretch"
    class="bmark-summary__client-orders__body"
  >
    <bmark-client-orders-blotter
      style="display: flex; flex-direction: column; flex: 1 1 auto"
      #bmarkClientOrders
      [orderIDsFromInput]="orderIds"
      [publishGridDataUpdateInfo]="true"
    ></bmark-client-orders-blotter>
  </div>
</div>
